import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Search } from 'lucide-react';
import { setActiveFilters } from '../../../redux/actions/filterActions';

const SearchBar = () => {
  const dispatch = useDispatch();
  const activeFilters = useSelector(state => state.filters.activeFilters);
  const [searchText, setSearchText] = useState(activeFilters.search || '');

  const handleInputChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearchClick = () => {
    dispatch(setActiveFilters({
      ...activeFilters,
      search: searchText
    }));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchClick();
    }
  };

  return (
    <div className="relative flex">
      <div className="relative flex-grow">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <input
          type="text"
          value={searchText}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          placeholder="Buscar productos..."
          className="w-full pl-9 pr-4 py-2 border rounded-l-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>
      <button
        onClick={handleSearchClick}
        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-r-md flex items-center justify-center"
      >
        <Search className="h-4 w-4" />
      </button>
    </div>
  );
};

export default SearchBar;